// TabsComponent.js
import React from 'react';
import { Tab, Tabs } from '@material-ui/core';
import { Create, Publish, School, Share, List } from '@material-ui/icons';
import { quCreateColor } from 'assets/jss/material-dashboard-pro-react';

// Styles
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/dashboardStyle.js";

const useStyles = makeStyles((theme) => ({
    ...styles,
}));

const TabsComponent = ({ activeTab, handleTabChange }) => {
    const classes = useStyles();

    return (
        <Tabs
            value={activeTab}
            onChange={handleTabChange}
            TabIndicatorProps={{
                style: {
                    backgroundColor: quCreateColor,
                    background: quCreateColor,
                }
            }}
            // indicatorColor={quCreateColor}
            centered
        >
            <Tab
                label={
                    <span style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                        <Create fontSize="small" /> Create
                    </span>
                }
                className={classes.customTab}
            />
            <Tab
                label={
                    <span style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                        <Publish fontSize="small" /> Publish
                    </span>
                }
                className={classes.customTab}
            />
            <Tab
                label={
                    <span style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                        <Share fontSize="small" /> Share
                    </span>
                }
                className={classes.customTab}
            />
            <Tab
                label={
                    <span style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                        <List fontSize="small" /> All
                    </span>
                }
                className={classes.customTab}
            />
        </Tabs>
    );
};

export default TabsComponent;
